<div class="dashboard-container flex justify-center mobile:px-5 laptop:px-8 overflow-y-auto">
  <div class="pt-5 w-343 tablet:w-768 laptop:w-912 tablet:px-6">
    <div class="flex justify-between content-center items-center mb-6 w-full">
      <div class="text-neutral-700 mt-6">
              <h1 class="text-7 tablet:text-8 font-medium pb-2">Good {{getTimeOfDay()}} {{userName}}</h1>
              <p class="mb-6 text-4">{{companyName}} have asked you to provide <span class="font-semibold text-4">{{referees.length}} references</span> for the role of {{role}}</p>
            </div>
      <img class="hidden tablet:block searching-img" src="/assets/searching.svg"/>
          </div>
    <div class="flex justify-center mt-6 mb-6" *ngFor="let referee of referees; index as i">
      <div class="flex flex-col">
        <referee-pending [refereeNumber]="i+1" (addDetails)="openRefereeForm(referee)" *ngIf="referee.firstName === null">
          <p class="referee-title">Referee {{i+1}}</p>
          <div class="flex items-center">
            <p class="reference-type">{{referenceTypes[referee.referenceType]}} Reference</p>
            <button class="tooltip-subject tooltip-manual-reference flex self-end" type="button" *ngIf="referee.referenceType === 0">
              <i class="fak fa-information text-neutral-500 text-7"></i>
              <div class="tooltip w-310 bottom-8 left-MINUS143">
                <div class="tooltip-content text-left text-3 leading-20">
                  A personal reference can be provided by someone who knows you outside of a work environment and can vouch for your character and skills.
                </div>
              </div>
            </button>
            <button class="tooltip-subject tooltip-manual-reference flex self-end" type="button" *ngIf="referee.referenceType === 1">
              <i class="fak fa-information text-neutral-500 text-7"></i>
              <div class="tooltip w-310 bottom-8 left-MINUS143">
                <div class="tooltip-content text-left text-3 leading-20">
                  A professional reference can be supplied from someone who has detailed information on your employment from an organisation where you have worked or are currently working.
                </div>
              </div>
            </button>
          </div>
        </referee-pending>
        <referee-completed [referee]="referee" [index]="i" (editDetails)="openRefereeForm(referee)" *ngIf="referee.firstName !== null">
        </referee-completed>
      </div>
    </div>
    <div class="flex justify-center mb-12" *ngIf="clientEmail">
      <div class="grid grid-cols-1 tablet:grid-cols-2 py-3 bg-light rounded">
        <div class="flex items-center w-343 tablet:w-768 laptop:w-864 pl-2">
          <i class="fak fa-talos-information text-6 text-info-200"></i>
          <p class="ml-1 mr-2 text-4 text-dark">If you are unable to supply any of the required information, please contact <a class="text-4 text-info-200" [href]="'mailto:' + clientEmail" target="_blank">{{companyName}}</a>.
        </div>
      </div>
    </div>
  </div>
</div>
